import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { Typography } from '../../../style';

type DropdownSelectProps = {
  name: string;
  selectedItems?: string[];
  bottomLabel?: string;
  inlineLabel?: string;
  hasToggleSwitch?: boolean;
  toggleText?: string;
  color?: string;
};

const DropdownSelect: FC<DropdownSelectProps> = (props) => {
  return (
    <Select data-testid='dropdown-select'>
      <div>
        <Typography
          theme={theme}
          size={theme.typography.h5}
          fontWeight={theme.typography.fontWeights.semibold}
          color={props.color}
        >
          {props.name}
        </Typography>
        <div>
          {props.inlineLabel && (
            <Typography size={theme.typography.h5}>{props.inlineLabel}</Typography>
          )}
        </div>
      </div>
      {props.hasToggleSwitch !== null ? (
        <Typography data-testid='dropdown-select-bottom-label' size={theme.typography.h6}>
          {props.toggleText}
        </Typography>
      ) : null}
      <div>
        {props.selectedItems && (
          <Typography size={theme.typography.h5}>{props.selectedItems}</Typography>
        )}
        {props.bottomLabel && (
          <Typography data-testid='dropdown-select-bottom-label' size={theme.typography.h6}>
            {props.bottomLabel}
          </Typography>
        )}
      </div>
    </Select>
  );
};

export default DropdownSelect;

const Select = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  line-height: 20px;
  & div:first-child {
    display: flex;
    justify-content: space-between;
  }
`;
